import {TicketTag} from './ticket-tag.model';
import {TicketEvent} from './ticket-event.model';
import {User} from '../../../core/auth/models/user.models';
import {TicketEmailVM} from '../components/emails/emails.model';
import {TicketEventVM} from './ticket-event.vm';

export type TicketStatus = 'TO_DO' | 'ASSIGNED' | 'IN_PROGRESS' | 'PENDING' | 'CLOSED' | 'MERGED'
export type TicketPriority = 'VERY_LOW'	| 'LOW'	| 'MEDIUM'	| 'HIGH' | 'URGENT'
export type TicketCategory = 'NOT_CATEGORIZED' | 'SUPPORT' | 'OTHER'
export type TicketAssigneeRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED'

export interface Ticket {
	id: string
	ticket_code: string
	userId: string
	subject: string
	initial_sender_email: string
	first_email_body: string
	status: TicketStatus
	category: TicketCategory
	last_inbound_at: Date
	assignee_user_id: string
	priority: TicketPriority
	updated_at?: string
	unread_inbound_count: number
	tags: TicketTag[]
	events?: TicketEvent[]
	emails?: TicketEmailVM[]
	eventsLoaded?: boolean
	emailsLoaded?: boolean
	eventsLoading?: boolean
	emailsLoading?: boolean
}

export interface TicketDashboardStat {
	id: string
	status: TicketStatus
	category: TicketCategory
	assignee_user_id: string | null
}

export type TicketCore = Omit<Ticket, 'events' | 'emails'>;

export interface TicketVM extends TicketCore {
	assignedUser?: User;
	assignedLabel: string;
	isAssigned: boolean;
	pendingAssigneeChange: boolean;
	isMergeTarget: boolean;
	mergeCount: number;
	mergedIds: string[];
	events?: TicketEventVM[];
	emails?: TicketEmailVM[];
}

export interface TicketAssigneeRequest {
	id: string
	ticket_id: string
	old_assignee_user_id: string
	requested_assignee_user_id: string
	status: TicketAssigneeRequestStatus
	reason: string
}

export interface TicketAssigneeRequestVM extends TicketAssigneeRequest {
	ticket_subject: string
	old_user_label: string
	new_user_label: string
}

export interface TicketAggregate {
	core: Ticket;

	events?: TicketEvent[];
	eventsLoaded?: boolean;
	eventsLoading?: boolean;

	emails?: TicketEmailVM[];
	emailsLoaded?: boolean;
	emailsLoading?: boolean;
}

export interface MergeReceivedDTO {
	ticket_id: string;
	merged_ticket_ids: string[];
}

export const TICKET_STATUSES: TicketStatus[] = [
	'TO_DO',
	'ASSIGNED',
	'IN_PROGRESS',
	'PENDING',
	'CLOSED',
	'MERGED'
]

export const TICKET_STATUSES_LABELS: Record<TicketStatus, string> = {
	TO_DO: 'Da fare',
	ASSIGNED: 'Assegnate',
	IN_PROGRESS: 'In corso',
	PENDING: 'In attesa',
	CLOSED: 'Chiuse',
	MERGED: 'Unite'
}

export const TICKET_STATUSES_COLOR: Record<TicketStatus, string> = {
	TO_DO: '#64748B',
	ASSIGNED: '#3B82F6',
	IN_PROGRESS: '#F59E0B',
	PENDING: '#8B5CF6',
	CLOSED: '#22C55E',
	MERGED: '#06B6D4'
}

export const TICKET_STATUS_OPTIONS = (Object.entries(TICKET_STATUSES_LABELS) as [TicketStatus, string][])
	.filter(([key]) => key !== 'MERGED')
	.map(([key, value]) => ({
		label: value,
		value: key
	}))

export const TICKET_CATEGORIES_LABEL: Record<TicketCategory, string> = {
	NOT_CATEGORIZED: 'Nessuna categoria',
	SUPPORT: 'Supporto',
	OTHER: 'Altro',
}

export const TICKET_CATEGORY_SLUGS: Record<TicketCategory, string> = {
	NOT_CATEGORIZED: 'non-categorizzati',
	SUPPORT: 'supporto',
	OTHER: 'altro'
}

export const TICKET_PRIORITY_FLOW: TicketPriority[] = [
	'VERY_LOW',
	'LOW',
	'MEDIUM',
	'HIGH',
	'URGENT'
];
